export const WHATSAPP_BOOKING_URL =
  "https://wa.me/919932142591?text=Hello%2C%20I%27d%20like%20to%20book%20an%20appointment.";

export const STUDIO_PHONE = "9932142591";
export const STUDIO_PHONE_DISPLAY = "+91 99321 42591";
export const STUDIO_ADDRESS = "Chinarpark, Kolkata";
export const STUDIO_MAP_URL = "https://maps.google.com/?q=22.6197117,88.4425421";
